export default "__VITE_ASSET__DrEJ_uXo__"